import React from 'react';
import { useTranslation } from 'react-i18next';
import { vrstaOpis, kasnjenjeTeksta, vremeTeksta } from './incidenti';
import { googleLinkTacke, otvoriGoogle } from './googleLinkovi';

/* Kartica jednog incidenta — radovi, zatvoren put, nezgoda.

   Redosled polja prati koliko šta menja odluku: prvo ŠTA je (vrsta), pa GDE
   (naslov je naziv deonice puta), pa KOLIKO KOŠTA (kašnjenje), pa DOKLE traje.
   Opis je poslednji jer je najduži, a najređe presudan.

   Zatvoren put dobija svoju traku na vrhu umesto da bude samo još jedan red:
   to je jedina vrsta posle koje ruta više ne važi, pa mora da se vidi pre nego
   što se bilo šta pročita. */

const Red = ({ naziv, vrednost }) => {
    if (vrednost === null || vrednost === undefined || vrednost === '') return null;
    return (
        <div className="gps-inc-red">
            <span className="gps-inc-naziv">{naziv}</span>
            <span className="gps-inc-vrednost">{vrednost}</span>
        </div>
    );
};

const PopupIncident = ({ incident }) => {
    const { t } = useTranslation();
    const o = vrstaOpis(incident.vrsta);
    const kasni = kasnjenjeTeksta(incident.kasnjenje);

    return (
        <div className="gps-incp">
            <div className="gps-incp-vrsta" style={{ '--inc-boja': o.boja }}>
                <i className={o.ikona} />
                {t(o.naziv)}
            </div>

            {!!incident.zatvoren && (
                <div className="gps-incp-zatvoren">
                    <i className="pi pi-ban" />
                    {t('gps.incPutZatvoren')}
                </div>
            )}

            <Red naziv={t('gps.incDeonica')} vrednost={incident.naslov} />

            {/* Kod zatvorenog puta kašnjenja nema i to nije propust podatka —
                zatvoren put nije „sporije" nego „ne može", pa se red i ne crta. */}
            <Red naziv={t('gps.incKasnjenje')} vrednost={kasni} />

            <Red naziv={t('gps.incOd')} vrednost={vremeTeksta(incident.pocetak)} />
            <Red naziv={t('gps.incDo')} vrednost={vremeTeksta(incident.zavrsetak)} />

            {/* Koliko daleko duž rute — stoji samo kad je incident nađen NA ruti
                izabranog vozila; u pregledu regiona ta brojka ne znači ništa. */}
            {incident.kmOdPocetka != null && (
                <Red naziv={t('gps.incNaRutiKm')}
                     vrednost={`${incident.kmOdPocetka.toLocaleString('sr-RS', { maximumFractionDigits: 1 })} km`} />
            )}

            {!!incident.opis && <div className="gps-incp-opis">{incident.opis}</div>}

            <button
                type="button"
                className="gps-incp-google"
                onClick={() => otvoriGoogle(googleLinkTacke(incident))}
            >
                <i className="pi pi-external-link" />
                {t('gps.pinOtvoriUGoogle')}
            </button>
        </div>
    );
};

export default PopupIncident;
